import * as React from 'react';
import { LoadingSpinner } from '@weddingspot/ws-core-components';

import { toUSD, SpinnerOverlay } from '@weddingspot/ws-core-components';
import cn from 'classnames';
import ShoppingCartCTAButton from '../shopping-cart-cta-button';

const styles = require('./VenuePrimaryCTA.scss');

interface State {
    ctaSpinning: boolean;
}

export interface PrimaryCTAProps {
    venueId: number;
    isPriced: boolean;
    isRdvProfile: boolean;
    startingPricePerPersonRDs?: number;
    budgetRangeMin?: number;
    budgetRangeCapacity?: number;
    estimateTotal?: number;
    onClickContact?: () => void;
    onClickQuote?: () => void;
    // Shopping Card Props
    venueName: string;
    venueLocation: string;
    venueImageUrl?: string;
    hideWeddingCosts?: boolean;
    shoppingListAllowed?: boolean;
    onAddVenue?: () => void;
    onRemoveVenue?: () => void;
    handleAddVenueToShoppingCart?: () => void;
    handleRemoveVenueFromShoppingCart?: () => void;
    sourcePage?: string;
    venueContractPackage?: string;
}

export default class PrimaryCTA extends React.Component<PrimaryCTAProps> {
    readonly state: State = {
        ctaSpinning: false,
    };

    constructor(props: PrimaryCTAProps) {
        super(props);
        this.setCtaSpinning = this.setCtaSpinning.bind(this);
    }

    renderHeader() {
        const props = this.props;

        // Show price per person for RD venue
        if (!props.hideWeddingCosts && props.isRdvProfile) {
            if (!!props.startingPricePerPersonRDs) {
                return (
                    <h3 className={cn(styles.headline, styles.hiddenMobile)}>
                        STARTING AT {toUSD(props.startingPricePerPersonRDs)} PER PERSON
                    </h3>
                );
            } else {
                return;
            }
        }

        // Show spot estimate if they user has one
        if (!!props.estimateTotal) {
            return (
                <h3 className={styles.headline}>
                    Your Spot Estimate:
                    <a href={`/pricing/${props.venueId}/estimate/`} className={styles.estimate} rel='nofollow'>
                        {`${toUSD(props.estimateTotal)}`}
                    </a>
                </h3>
            );
        }

        // Show budget range if venue is priced
        if (!props.hideWeddingCosts && props.isPriced && !!props.budgetRangeMin && !!props.budgetRangeCapacity) {
            return (
                <h3 className={styles.headline + ' ' + styles.hiddenMobile}>
                    STARTING AT {toUSD(props.budgetRangeMin)} FOR {props.budgetRangeCapacity} GUESTS
                </h3>
            );
        }

        return;
    }

    renderCtaText() {
        const props = this.props;

        if (!props.isRdvProfile) {
            if (!!props.estimateTotal) {
                return (
                    <p className={styles.text}>Don't miss out! Send a message now to check availability and receive more information.</p>
                );
            }

            if (props.isPriced && !!props.budgetRangeMin && !!props.budgetRangeCapacity) {
                return <p className={styles.text}>Price this venue to get your customized estimate, no strings attached</p>;
            }
        }

        return;
    }

    renderCtaButton() {
        const props = this.props;

        if (!!props.estimateTotal && !props.isRdvProfile) {
            if (props.shoppingListAllowed) {
                return (
                    <ShoppingCartCTAButton
                        venueId={props.venueId}
                        venueName={props.venueName}
                        venueLocation={props.venueLocation}
                        venueImageUrl={props.venueImageUrl}
                        sourcePage={props.sourcePage}
                        venueContractPackage={props.venueContractPackage}
                    />
                );
            } else {
                return (
                    <button className={cn('nx-button', 'nx-button--primary', styles.button)} onClick={props.onClickContact}>
                        CONTACT VENUE
                    </button>
                );
            }
        }

        if (props.isPriced && !props.isRdvProfile) {
            return (
                <SpinnerOverlay
                    isSpinning={this.state.ctaSpinning}
                    spinnerProps={{
                        spinnerColor: 'white',
                        spinnerDiameter: 30,
                    }}
                >
                    <a
                        className={cn('nx-button', 'nx-button--primary', styles.button)}
                        href={`/pricing/${props.venueId}/estimate/`}
                        onClick={this.setCtaSpinning}
                        itemType='price-this-venue'
                        rel='nofollow'
                    >
                        PRICE THIS VENUE
                    </a>
                </SpinnerOverlay>
            );
        } else {
            return (
                <button
                    className={cn('nx-button', 'nx-button--primary', styles.button)}
                    onClick={props.onClickQuote}
                    itemType='request-quote'
                >
                    REQUEST A QUOTE
                </button>
            );
        }
    }

    public render() {
        if (!this.props.venueId) {
            return (
                <div className={styles.className}>
                    <LoadingSpinner />
                </div>
            );
        }

        return (
            <div className={styles.className}>
                {this.renderHeader()}
                {this.renderCtaText()}
                {this.renderCtaButton()}
            </div>
        );
    }

    private setCtaSpinning() {
        this.setState({ ctaSpinning: true });
    }
}
